/* eslint-disable no-unused-vars */
import { OS_TYPE, SaleType } from 'models/magazine'
import {
  SETTING_BANNER,
  SETTING_MAGAZINE_SELL_ONCE,
  SETTING_MAGAZINE_SUBCRIBE,
  SETTING_NOTIFICATION,
  SETTING_SUBSCRIBER_ID,
  SETTING_APP
} from './path'
import { ConditionDevice, StatusNoti } from 'models/notification'
import { roleType } from 'models/user'

// define constant here
export const STORAGE_TOKEN_KEY = 'TOKEN'
export const STORAGE_TOKEN_ADMIN = 'TOKEN_ADMIN'
export const DATE_FORMAT = 'YYYY/MM/DD'
export const DATE_FORMAT_PUSH = 'YYYY-MM-DD'
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const DATE_TIME_FORMAT_PUSH = 'YYYY-MM-DD HH:mm:ss'
export const DATE_FORMAT_DISPLAY = 'YYYY年MM月DD日'
export const MONTH_FORMAT_DISPLAY = 'YYYY年MM月'
export const MONTH_FORMAT_PUSH = 'YYYY-MM'
export const DATE_TIME_FORMAT_DISPLAY = 'YYYY年MM月DD日HH:mm'
export const DEFAULT_PAGE = 1
export const PER_PAGE = 12
export const PER_PAGE_SELECT = 200
export const MAX_TITLE_LENGTH = 255
export const MAX_FILE_SIZE = 2147483648 // 2GB
export const MAX_HOUR = 23
export const MAX_MINUTE = 59
export const ERROR_CODE_422 = 422
export const MAINTENANCE_REDIRECTED = 'maintenance-redirected'

export const PAGE_SETTING = [
  {
    name: '定期配信設定',
    path: SETTING_MAGAZINE_SUBCRIBE
  },
  {
    name: '単冊販売設定',
    path: SETTING_MAGAZINE_SELL_ONCE
  },
  {
    name: '購読ID設定',
    path: SETTING_SUBSCRIBER_ID
  },
  {
    name: '通知設定​',
    path: SETTING_NOTIFICATION
  },
  {
    name: 'バナー設定​',
    path: SETTING_BANNER
  },
  {
    name: 'アプリ設定​',
    path: SETTING_APP
  }
  // {
  //   name: 'ログ分析',
  //   path: 'h'
  // }
]
export const DisplayOs = {
  [OS_TYPE.IOS]: 'iOS',
  [OS_TYPE.ANDROID]: 'Android',
  [OS_TYPE.WEB]: 'ブラウザ'
}

export const OsOptions = [
  {
    label: 'iOS',
    value: OS_TYPE.IOS
  },
  {
    label: 'Android',
    value: OS_TYPE.ANDROID
  },
  {
    label: DisplayOs[OS_TYPE.WEB],
    value: OS_TYPE.WEB
  }
]

export const DisplayConditionDevice = {
  [ConditionDevice.NEW_APP]: '以内にアプリを新規インストールした端末',
  [ConditionDevice.START_APP]: '以内にアプリを起動した端末​',
  [ConditionDevice.NOT_START_APP]: '以上アプリを起動していない端末'
}

export const DisplayStatusNoti = {
  [StatusNoti.WAIT]: '未送信',
  [StatusNoti.SUCCESS]: '送信済​',
  [StatusNoti.FAIL]: '送信失敗'
}

export const DisplayRole = {
  [roleType.ADMIN]: '管理者',
  [roleType.USER]: '一般'
}

export const DisplaySellType = [
  {
    label: 'しない',
    value: SaleType.NOT_SOLE_YET
  },
  {
    label: '有料',
    value: SaleType.ONCE
  },
  {
    label: '無料',
    value: SaleType.FREE
  }
]
export enum ExportType {
  default = 1,
  withIdDigital = 2,
  withMonth = 3,
  withDay = 4,
  specialApp = 5
}

export const ExportUsageStatus = [
  {
    label: 'ID別',
    value: ExportType.withIdDigital
  },
  {
    label: '月別',
    value: ExportType.withMonth
  },
  {
    label: '日別',
    value: ExportType.withDay
  }
]

export enum SubcriptionsStatus {
  NOT_SETUP = 1,
  SETUP_DONE = 2,
  PENDING = 3
}

export const SubscriptionsStatus: Record<string, number> = {
  ACTIVE: SubcriptionsStatus.SETUP_DONE,
  INACTIVE: SubcriptionsStatus.PENDING,
  DRAFT: SubcriptionsStatus.PENDING
}

export const SubscriptionsStatusLabel = {
  [SubcriptionsStatus.NOT_SETUP]: '未設定',
  [SubcriptionsStatus.SETUP_DONE]: '有効',
  [SubcriptionsStatus.PENDING]: '無効'
}

export const SubscriptionsType = [
  {
    label: '無料',
    value: 1
  },
  {
    label: '1週間',
    value: 2
  },
  {
    label: '1ヶ月',
    value: 3
  },
  {
    label: '2ヶ月',
    value: 4
  },
  {
    label: '3ヶ月',
    value: 5
  },
  {
    label: '6ヶ月',
    value: 6
  },
  {
    label: '1年',
    value: 7
  }
]

export const SubscriptionsInitial = [
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 1,
    os_type: OS_TYPE.IOS,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 2,
    os_type: OS_TYPE.IOS,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 3,
    os_type: OS_TYPE.IOS,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 4,
    os_type: OS_TYPE.IOS,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 5,
    os_type: OS_TYPE.IOS,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 6,
    os_type: OS_TYPE.IOS,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 7,
    os_type: OS_TYPE.IOS,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 1,
    os_type: OS_TYPE.ANDROID,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 2,
    os_type: OS_TYPE.ANDROID,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 3,
    os_type: OS_TYPE.ANDROID,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 4,
    os_type: OS_TYPE.ANDROID,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 5,
    os_type: OS_TYPE.ANDROID,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 6,
    os_type: OS_TYPE.ANDROID,
    product_id: '',
    name: ''
  },
  {
    id: 0,
    app_magazine_id: 0,
    status: SubcriptionsStatus.NOT_SETUP,
    type: 7,
    os_type: OS_TYPE.ANDROID,
    product_id: '',
    name: ''
  }
]
export const REGEX_NUMBER = /^\d*$/
export const REGEX_TABLE_OF_CONTENT = /^(\p{L}+)\s+(\p{N}+)\s*$/gmu
export const REGEX_NOT_COMMAS = '^[^,]*$'


export const REGEX_PAGE_INPUT_PAGE_SINGLE = /^(\d+(-\d+)?(?:,\s*\d+(-\d+)?)*)(?:,\s*\d+(-\d+)?)?$/

export const ERROR_CREATE_APP_COINCDDE: Record<string, string> = {
  app_name: '「書籍（アプリ）名称（日本語）」の項目は既に存在します。',
  latin_name: '「書籍（アプリ）名称（英数字）」の項目は既に存在します。',
  android_app_id: 'パッケージ名は既に存在します。',
  ios_app_id: ' バンドルIDは既に存在します。'
}

export const IS_TRUE = 1
export const IS_FALSE = 0

export const BREAK_LINE_REGEX= /\r\n|\n|\r/
export const BREAK_LINE_REGEX_GLOBAL= /\r\n|\n|\r/g
export const STATUS_NOT_FOUND = 404
export const MAX_LENGTH_DESCRIPTION_MAGAZINE = 800
export const APP_SPECIAL = ['プレジデント']
